module.exports = __webpack_public_path__ + "img/computer_web.11885f8c.png";